import { uploadDocument } from '@klear/ui/lib/upload-document'

export function useUploadOrderEventDocuments() {
  const uploadOrderEventDocuments = async (args: {
    files: File[]
    orderEventId: number
    traderId: number
  }): Promise<void> => {
    for (const file of args.files) {
      await uploadDocument(args.traderId, file, {
        fileOn: { kind: 'order_event', id: args.orderEventId },
        batchSize: args.files.length
      })
    }
  }

  return { uploadOrderEventDocuments }
}
